import { sdk, STATIC_MEDIA_URL } from '@wix/image-kit';

/** Display size in CSS pixels for each AppIcon variant. */
export const APP_ICON_DISPLAY_SIZE_PX = {
  small: 42,
  medium: 54,
} as const;

/**
 * Fetch icons at 3x display size so they stay sharp on retina screens
 * when downscaled in the browser (matches legacy SolutionBox behavior).
 */
export const APP_ICON_SOURCE_SCALE = 3;

export const getAppIconSourceSize = (
  size: keyof typeof APP_ICON_DISPLAY_SIZE_PX,
): number => APP_ICON_DISPLAY_SIZE_PX[size] * APP_ICON_SOURCE_SCALE;

export interface ResizeImageParams {
  imageUrl: string;
  originalWidth: number;
  originalHeight: number;
  toWidth: number;
  toHeight: number;
}

export const useResizeImage = (): (({
  imageUrl,
  originalWidth,
  originalHeight,
  toWidth,
  toHeight,
}: ResizeImageParams) => string) => {
  return ({ imageUrl, originalWidth, originalHeight, toWidth, toHeight }) => {
    const relativeUrl = imageUrl.replace(STATIC_MEDIA_URL, '');
    return sdk.getScaleToFillImageURL(
      relativeUrl,
      originalWidth,
      originalHeight,
      toWidth,
      toHeight,
      // Force DPR=1 so SSR and client produce identical URLs. Source is already 3x
      // display size for retina sharpness.
      { isSEOBot: true },
    );
  };
};
